import { Action } from '@ngrx/store';

export enum ActionTypes {
  FETCH_CONTRACTS = '[Bulk CEM UL Modify] Fetch Contracts',
  ADD_CONTRACTS = '[Bulk CEM UL Modify] Add Contracts',
  CLEAR_CONTRACTS = '[Bulk CEM UL Modify] Clear Contracts',
  NO_ACTION = '[Bulk CEM UL Modify] No Action',
}

export class FetchContracts implements Action {
  readonly type = ActionTypes.FETCH_CONTRACTS;
  constructor(
    public payload: { orderFormId: number; productId: number; jobsiteId: number; shippingConditionId: number },
  ) {}
}

export class AddContracts implements Action {
  readonly type = ActionTypes.ADD_CONTRACTS;
  constructor(public payload: { orderFormId: number; contracts: any[] }) {}
}

export class ClearContracts implements Action {
  readonly type = ActionTypes.CLEAR_CONTRACTS;
  constructor() {}
}

export class NoAction implements Action {
  readonly type = ActionTypes.NO_ACTION;
  constructor() {}
}

export type Actions = FetchContracts | AddContracts | ClearContracts | NoAction;
